import React from 'react';
import Styles from './styles.js';
const TitleBgYellow = () => {
  return (
    <div>
      <div className="w-full md:py-5" style={{ backgroundColor: '#FCBD00' }}>
        <div className="container px-6 lg:px-0 mx-auto   pt-4 md:pt-0   ">
          <div className="flex pt-5 pb-5 justify-center  ">
            <div className=" px-0 py-5">
              <div>
                <h3
                  className="uppercase text-[32px] md:text-[38px] lg:text-[44px] leading-[50px]  font-normal  text-center"
                  style={{ fontFamily: 'Fjalla One', color: '#000000' }}>
                  ARRIVE'S SOULROOMS OFFER FOR NEW IMMIGRANTS.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles />
    </div>
  );
};

export default TitleBgYellow;
